<template>
    <div class="container">
        <div class="card card-default">
            <div class="card-header">Registeration</div>
            <div class="card-body">
                <div class="alert alert-danger" v-if="has_error && !success">  
                    <p>Some msg</p>
                </div>
                <form autocomplete="off" v-if="!success" method="post">
                  
                   
                    <div class="form-group">
                        <label for="email">E-mail</label>
                        <input type="email" id="email" class="form-control" placeholder="user@example.com" v-model="email">
                    </div>
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" id="password" class="form-control" v-model="password">
                    </div>
                    <div class="form-group">
                        <label for="email">Role</label>
                        <v-select :model= "selectedRole" :options= "roles" @input="rollout"></v-select>
                    </div>
                    <button type = "button" @click="register()" class="btn btn-primary">Register</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        name: '',
        email: '',
        password: '',
        has_error: false,
        error: '',
        roles: [{label:'Admin',key:1},{label:'Employee',key:2}],
        selectedRole:0,
        errors: {},
        success: false,
      
      }
    },
    methods: {
        rollout(option)
        {
           this.selectedRole = option.key
        },
      register() {
        var app = this
    
        this.$auth.register({
          data: {
            UserName: app.email,
            password: app.password,
            Role:this.selectedRole
          },
          }).then(()=>
          {
            app.success = true
            this.$router.push({name: 'login', params: {successRegistrationRedirect: true}})
          }, ()=>{
            app.has_error = true
          })
         
      }
    }
  }
</script>